export const mapRequisitionApiToModel = (apiReq) => {
  if (!apiReq) return null;

  return {
    isActive: apiReq.isActive ?? false,

    created_by: apiReq.createdBy || "",
    updated_by: apiReq.modifiedBy || "",
    created_date: apiReq.createdDate || "",
    updated_date: apiReq.modifiedDate || "",

    requisition_id: apiReq.id || "",
    requisition_code: apiReq.requisitionCode || "",
    requisition_title: apiReq.requisitionTitle || "",
    requisition_description: apiReq.requisitionDescription || "",

    registration_start_date: apiReq.startDate || "",
    registration_end_date: apiReq.endDate || "",
    requisition_status: apiReq.requisitionStatus || "",
    requisition_comments: apiReq.requisitionComments || "",
    indent_path: apiReq.indentPath || "",
    department_count: apiReq.departmentCount ?? 0,
    position_count: apiReq.positionCount ?? 0,
    vacancy_count: apiReq.vacancyCount ?? 0,
  };
};

export const mapRequisitionsApiToList = (apiList = []) => {
  if (!Array.isArray(apiList)) return [];
  return apiList.map(mapRequisitionApiToModel);
};
